import { render } from "./formApplicationVideoProduction.vue?vue&type=template&id=6c50e37e"
import script from "./formApplicationVideoProduction.vue?vue&type=script&lang=js"
export * from "./formApplicationVideoProduction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__